var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__money-view"},[_c('span',[_vm._v(_vm._s(_vm.amount?_vm.amount.toFixed(3):0))]),_c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm.currencyLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }